import * as React from 'react';
import withStyles, {
  WithStyles,
  StyleRules
} from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles';
import { TextFieldProps } from '@material-ui/core/TextField';
import MomentUtils from '@date-io/moment';
import classNames from 'classnames';


import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { CommunicationStayPrimaryLandscape } from 'material-ui/svg-icons';

const styles = (theme: Theme): StyleRules => ({
  datePicker: {
    marginTop: 0,
    width: '100%',
  }
});

interface Props extends TextFieldProps {
  value: any | undefined;
  autoOk?: boolean;
  keyboard?: boolean;
  clearable?: boolean;
  placeholder?: string;
  invalidLabel?: string;
  invalidDateMessage?: string;
  format?: string;
  className?: string;
  required?: boolean;
  minDate?: any;
  maxDate?: any;
  // End of day denotes that the time of day should be set to 23:59:59 when selecting or entering a date, as opposed to the default of 00:00:00
  endOfDay?: boolean;
  disablePast?: boolean;
  disableFuture?: boolean;
  animateYearScrolling?: boolean;
  openToYearSelection?: boolean;
  shouldDisableDate?: (day: any) => boolean;
  id?: any;
  style?: any;
  onKeydown?: (evt: any) => void;
  name?: string
  error?: any
  disabled?: boolean
  onChange?: any
  isKeyField?: boolean;
  useNoonTime?: boolean;
}

type State = {
  dateVal: string;
  newDateVal?: Date;
};

class DateField extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      dateVal: props.value || ''
    };
  }
  UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {

    this.setState({ dateVal: newProps.value || '' });
  }

  onDateBlur = (date: any) => {

    if (date && date.target && date.target.value) {
      const mu = new MomentUtils();
      const d = mu.parse(date.target.value, "MM/DD/YYYY");
     
      // Be sure the date actually changed before calling this
      const dv = this.state.dateVal;
      if (!this.state.dateVal || d.format("MM/DD/YYYY") != (new Date(this.state.dateVal)).toLocaleDateString('en-US', {month: '2-digit', day: '2-digit', year: 'numeric'})) {
        if (this.props.onChange && d.isValid && d.isValid()) {
          if (this.props.endOfDay) {
            this.props.onChange(d.endOf('day') as any);
          } else {
            this.props.onChange(d.startOf('day') as any);
          }
        } else {
          // We have a value, but cannot parse it, so default to today?
          const today = mu.moment(new Date());
          this.props.onChange(today);
          this.setState({ dateVal: today });
        }
      }
    } else {
      this.setState({ dateVal: '' });
    }
  };
  onDateChange = (date: any) => {


    const self = this;

    if (date && date.isValid && date.isValid()) {
      if (this.props.onChange) {
        // Using startOf day here to strip the time component, since this is only a date control and validation errors occur based on extranious time data, unless end of day is used for the end of a range or otherwise
        if (this.props.useNoonTime) { //This is being added for dates such as Invoice Date causing issues betwen TZ
          this.props.onChange(date.set('hour', 12));
        } else if (this.props.endOfDay) {
          this.props.onChange(date.endOf('day'));
        } else {
          this.props.onChange(date.startOf('day'));
        }
      }
    } else {
      const mu = new MomentUtils();
      this.setState(
        {
          // MAY Not be needed for new material UI from what I'm seeing
          // try to reset this to today, if the date is invalid to give the underlying control a valid date to work with.
          // dateVal: new Date() //this.props.value
          dateVal: null
        },
        () => {
          if (self && self.props && self.props.onChange) {
            if (this.props.onChange) {
              self.props.onChange(null as any);
            }
          }
        }
      );
    }
  };

  handleDateChange = (date) => {
    // setSelectedDate(date);

  };

  onBlur = (event: any) => {
    console.log("onBlur")
    // var numericRegex = /(\d\d)(\d\d)(\d\d)/
    // var val = event.target.value.replace(/_/g, "");
    // val = val.replace(/\//g, "");
    // if (val && val.length == 6) {
    //     var numericMatch = val.match(numericRegex)
    //     if (numericMatch && numericMatch.length == 4) {
    //         var date: any;
    //         date = moment(`${numericMatch[1]}/${numericMatch[2]}/20${numericMatch[3]}`)
    //         this.setState({
    //             dateVal: date
    //         }, ()=>{
    //             if(this.props.onChange) {
    //                 this.props.onChange(date)
    //             }
    //         })
    //     }
    // }
  };

  onKeydown = (e: any) => {
    if (this.props.onKeydown) {
      this.props.onKeydown(e);
    }
  };

  render() {
    // const { classes }: { classes:ClassNameMap } = this.props
    const {
      label,
      helperText,
      keyboard,
      invalidLabel,
      invalidDateMessage,
      format,
      clearable,
      placeholder,
      classes,
      autoOk,
      className
    } = this.props;
    const { dateVal } = this.state;

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <KeyboardDatePicker
          InputLabelProps={{
            shrink: true
          }}
          InputAdornmentProps={{
            tabIndex: -1
          }}
          inputProps={{
            name: this.props.name || "date_picker_input"
          }}
          helperText={helperText}
          clearable={clearable == undefined ? true : clearable}
          placeholder={placeholder == undefined ? 'MM/DD/YYYY' : placeholder}
          autoOk={autoOk}
          name={this.props.name || "date_picker"}
          margin="normal"
          error={this.props.error}
          // id="date-picker-dialog"
          label={<span>{label}{this.props.isKeyField && !this.props.required && <i style={{ color: "#CD5C5C", marginLeft: 5 }} className="fa fa-key"></i>}</span>}
          format={format == undefined ? 'MM/DD/YYYY' : format}
          value={dateVal != "" ? dateVal : null}
          onChange={this.onDateChange}
          onBlur={this.onDateBlur}
          style={this.props.style}
          className={classNames(classes.datePicker, className)}  
          minDate={
            this.props.minDate ||
            new Date(new Date().setFullYear(new Date().getFullYear() - 2))
          }
          maxDate={
            this.props.maxDate ||
            new Date(new Date().setFullYear(new Date().getFullYear() + 2))
          }
          invalidDateMessage={
            invalidDateMessage == undefined ? '' : invalidDateMessage
          }
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
          disabled={this.props.disabled}
          required={this.props.required}
        />
      </MuiPickersUtilsProvider>
    );
  }
}

export default withStyles(styles)(DateField);